import * as utils from '../apiUtils';
import * as common from '../apiCommon';
import { ITEM_NUMBER_TYPE } from '../../constants/constant_doc_types';

export const saveItemNumberType = (app, params) => {
  const { user = {}, data } = params;

  const doc = {
    doc_type: ITEM_NUMBER_TYPE,
    active: utils.toBoolean(data.active),
    name: utils.toStringText(data.name),
    short_name: utils.toStringText(data.short_name),
    system_defined: utils.toBoolean(data.system_defined),
  };

  return common.saveDoc(app, { source: data, doc, user });
};

export const deleteItemNumberType = (app, params) =>
  common.deleteDoc(app, { id: params.id, docType: ITEM_NUMBER_TYPE });

export const fetchItemNumberTypeById = (app, params) => {
  const { id } = params;
  const docType = ITEM_NUMBER_TYPE;
  return common.getDoc(app, { id, docType });
};

export function fetchItemNumberTypeDropdown(app, params) {
  const { searchTerm, searchParams, fields, id } = params;
  const dropdown_type = 'item_number_type/dropdown';
  const query = {
    id,
    dropdown_type,
    fields,
    searchTerm,
    searchParams,
  };

  return common.getDropdownList(app, { query });
}
